import React from 'react';
import { Button } from '@mantine/core';
import { IconFilterOff, IconSearchOff } from '@tabler/icons-react';
import EmptyState from '@/components/ui/Empty.State';
import type { TypeListFindBar } from '@/types/list/types.list.find';

const ListFindEmpty: React.FC<{ bar: TypeListFindBar }> = ({ bar }) => {
    const searching = Boolean(bar.search.trim());
    const filtering = Object.values(bar.active).some((values) => values.length > 0) || Object.keys(bar.dateValues).length > 0;
    const body = searching && filtering
        ? `Niente corrisponde a «${bar.search.trim()}» con i filtri scelti. Prova a togliere un filtro o a cercare meno parole.`
        : searching
            ? `Niente corrisponde a «${bar.search.trim()}». Prova con meno parole o con un altro termine.`
            : 'Nessun elemento passa i filtri scelti. Togline qualcuno per allargare la ricerca.';

    return (
        <EmptyState
            icon={searching ? IconSearchOff : IconFilterOff}
            title="Nessun risultato"
            body={body}
            action={<Button variant="default" size="sm" leftSection={<IconFilterOff size={16} />} onClick={bar.onReset}>{searching && !filtering ? 'Svuota la ricerca' : 'Cancella ricerca e filtri'}</Button>}
        />
    );
};

export default ListFindEmpty;
